module.exports = __webpack_public_path__ + "static/img/bg-centent.a8299d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-centent.jpg
// module id = Svw1
// module chunks = 1